(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],2:[function(require,module,exports){
(function (setImmediate){
'use strict';

/**
 * @this {Promise}
 */
function finallyConstructor(callback) {
  var constructor = this.constructor;
  return this.then(
    function(value) {
      // @ts-ignore
      return constructor.resolve(callback()).then(function() {
        return value;
      });
    },
    function(reason) {
      // @ts-ignore
      return constructor.resolve(callback()).then(function() {
        // @ts-ignore
        return constructor.reject(reason);
      });
    }
  );
}

// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function isArray(x) {
  return Boolean(x && typeof x.length !== 'undefined');
}

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

/**
 * @constructor
 * @param {Function} fn
 */
function Promise(fn) {
  if (!(this instanceof Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  /** @type {!number} */
  this._state = 0;
  /** @type {!boolean} */
  this._handled = false;
  /** @type {Promise|undefined} */
  this._value = undefined;
  /** @type {!Array<!Function>} */
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function() {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

/**
 * @constructor
 */
function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

Promise.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

Promise.prototype.then = function(onFulfilled, onRejected) {
  // @ts-ignore
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.prototype['finally'] = finallyConstructor;

Promise.all = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!isArray(arr)) {
      return reject(new TypeError('Promise.all accepts an array'));
    }

    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function(resolve) {
    resolve(value);
  });
};

Promise.reject = function(value) {
  return new Promise(function(resolve, reject) {
    reject(value);
  });
};

Promise.race = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!isArray(arr)) {
      return reject(new TypeError('Promise.race accepts an array'));
    }

    for (var i = 0, len = arr.length; i < len; i++) {
      Promise.resolve(arr[i]).then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn =
  // @ts-ignore
  (typeof setImmediate === 'function' &&
    function(fn) {
      // @ts-ignore
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

module.exports = Promise;

}).call(this,require("timers").setImmediate)
},{"timers":3}],3:[function(require,module,exports){
(function (setImmediate,clearImmediate){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
}).call(this,require("timers").setImmediate,require("timers").clearImmediate)
},{"process/browser.js":1,"timers":3}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendSocialGoals = exports.sendFBGoal = exports.sendVKGoal = exports.sendGoals = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var localYmCounterKey = '';

var _tmr = window._tmr || (window._tmr = []);

window.dataLayer = window.dataLayer || [];

window.gtag = function () {
  dataLayer.push(arguments);
};

window.addEventListener("load", function () {
  var ymCountersKeys = Object.keys(window).filter(function (el) {
    return /^yaCounter.*?/i.test(el);
  });
  localYmCounterKey = ymCountersKeys[0];
});

var sendGoals = function sendGoals(ymGoal, gaGoal, gadsGoal, tmrGoal, ga4Goal) {
  if (Array.isArray(ymGoal)) {
    ymGoal.forEach(function (goal) {
      return sendYMGoal(goal);
    });
  } else {
    sendYMGoal(ymGoal);
  }

  if (typeof gtag !== 'undefined' && ga4Goal && typeof ga4Goal !== 'undefined' && ga4Goal.id !== '') {
    var $params = {};

    if (ga4Goal.params) {
      ga4Goal.params.forEach(function (param) {
        $params[param.key] = param.value;
      });
    }

    gtag("event", ga4Goal.id, $params);
  } // if (typeof ga === 'function' && typeof gaGoal !== 'undefined' && typeof gaGoal.label !== 'undefined' && typeof gaGoal.action !== 'undefined' && typeof gaGoal.category !== 'undefined') {
  //   ga('send', 'event', gaGoal.category, gaGoal.action, gaGoal.label);
  // }


  if (gadsGoal) {
    if (typeof gtag !== 'undefined' && typeof gadsGoal !== 'undefined' && typeof gadsGoal.goal !== 'undefined' && typeof gadsGoal.id !== 'undefined') {
      gtag('event', 'conversion', {
        'send_to': gadsGoal.id + '/' + gadsGoal.goal
      });
    }
  }

  if (_typeof(_tmr) === 'object' && tmrGoal) {
    sendTMRGoal(tmrGoal.id, tmrGoal.goal);
  }
};

exports.sendGoals = sendGoals;

function sendYMGoal(goal) {
  if (goal && window[localYmCounterKey]) {
    window[localYmCounterKey].reachGoal(goal);
  }
}

var sendTMRGoal = function sendTMRGoal(id, goal) {
  if (_tmr && goal) {
    _tmr.push({
      id: id,
      type: "reachGoal",
      goal: goal
    });
  }
};

var sendVKGoal = function sendVKGoal(goal) {
  if ((typeof VK === "undefined" ? "undefined" : _typeof(VK)) === 'object') {
    VK.Goal(goal);
  }
};

exports.sendVKGoal = sendVKGoal;

var sendVKEvent = function sendVKEvent(goal) {
  if ((typeof VK === "undefined" ? "undefined" : _typeof(VK)) === 'object' && VK.Retargeting) {
    VK.Retargeting.Event(goal);
  }
};

var sendFBGoal = function sendFBGoal(goal) {
  if (typeof fbq === 'function' && goal) {
    fbq('track', goal);
  }
};

exports.sendFBGoal = sendFBGoal;

var sendSocialGoals = function sendSocialGoals(_ref) {
  var fbGoal = _ref.fbGoal,
      vkGoal = _ref.vkGoal,
      vkEvent = _ref.vkEvent;
  if (fbGoal) sendFBGoal(fbGoal);
  if (vkGoal) sendVKGoal(vkGoal);
  if (vkEvent) sendVKEvent(vkEvent);
};

exports.sendSocialGoals = sendSocialGoals;

},{}],5:[function(require,module,exports){
"use strict";

require("./app/polyfills");

require("./app/owl");

require("./app/lazy-load");

require("./app/form");

require("./app/dropdown");

require("./app/scroll");

require("./app/modal");

require("./app/init");

require("./app/banner");

require("./app/main-carousel-animate");

require("./new/inputs");

},{"./app/banner":6,"./app/dropdown":7,"./app/form":8,"./app/init":9,"./app/lazy-load":10,"./app/main-carousel-animate":11,"./app/modal":12,"./app/owl":13,"./app/polyfills":14,"./app/scroll":15,"./new/inputs":16}],6:[function(require,module,exports){
"use strict";

(function (window, document, $) {
  var $banner = $('.banner');

  if ($banner) {
    var setBannerCookies = function setBannerCookies(dataBanner) {
      var cookieName = dataBanner === 'locale' ? 'qtrans_front_language_picked' : "itglobal_banner_".concat(dataBanner, "_viewed");
      Cookies.set(cookieName, 'on', {
        expires: 30,
        path: '/'
      });
    };

    $banner.find('a').on('click', function () {
      var dataBanner = $(this).closest('.banner').attr('data-banner');
      setBannerCookies(dataBanner);
    });
    $('.btn-no').on('click', function () {
      var $banner = $(this).closest('.banner');
      var $text = $banner.find('.banner-empty__text');
      $banner.find('.banner-locale__entry').css('display', 'none');
      $banner.find('.banner-locale__langs').addClass('show');
      $text.text($text.data('text'));
    });
    $('button.close, #close-picker').on('click', function () {
      var $banner = $(this).closest('.banner');
      $banner.slideUp();
      setBannerCookies($banner.attr('data-banner'));
    });
  }
})(window, document, jQuery);

},{}],7:[function(require,module,exports){
"use strict";

var _promisePolyfill = _interopRequireDefault(require("promise-polyfill"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (window, document, $) {
  var dropdownMenus = document.querySelectorAll('.navbar .dropdown-menu');

  var menusCalculate = function menusCalculate() {
    var windowWith = document.body.clientWidth;
    dropdownMenus.forEach(function (item, key) {
      new _promisePolyfill.default(function (resolve) {
        if (item.classList.contains('dropdown-menu--wide')) {
          var menuCols = item.querySelectorAll('.dropdown-menu__col');
          item.style.width = menuCols.length * 267 + 'px';
        }

        resolve();
      }).finally(function () {
        var itemRect = item.getBoundingClientRect();

        if (itemRect.left + itemRect.width > windowWith) {
          var itemParentRect = item.closest('.dropdown').getBoundingClientRect();
          var leftOffset = windowWith - itemRect.width - itemParentRect.left - itemParentRect.width;
          item.style.left = leftOffset + 'px';
          item.style.right = 'auto';
          var pointer = item.querySelector('.dropdown-menu__pointer');
          pointer.style.left = itemParentRect.left - item.getBoundingClientRect().left + itemParentRect.width / 4 + 'px';
        }
      });
    });
    var navBar = document.querySelector('.navbar-nav');

    if (navBar) {
      navBar.classList.remove('overflow-hidden');
    }

    $('.main-nav').find('.dropdown-menu').addClass('d-flex');
    $('.lang-switcher').find('.dropdown-menu').addClass('d-flex');
  };

  if (dropdownMenus.length > 0) {
    window.addEventListener('DOMContentLoaded', function () {
      return menusCalculate();
    });
    window.addEventListener('resize', function () {
      return menusCalculate();
    });
  }
})(window, document, jQuery);

},{"promise-polyfill":2}],8:[function(require,module,exports){
"use strict";

var _utils = require("../../../js/app/utils");

(function (window, document, $) {
  // init Bootstrap select
  var $select = $('.selectpicker');
  var selectpicker = $select.selectpicker({
    noneSelectedText: '',
    styleBase: 'form-control',
    width: '100%'
  });
  selectpicker.on('changed.bs.select', function () {
    $select.parents('.bootstrap-select').addClass('selected');
  });
  $(document).on('submit', '.form', function (e) {
    e.preventDefault();
    var $form = $(this),
        isModal = $form.hasClass('form-modal');
    var $modal, $wrapper, $loader;

    if (isModal) {
      $modal = $form.parents('.modal');
      $loader = $modal.find('.loader');
    } else {
      $wrapper = $form.parents('.form-wrapper');
      $loader = $wrapper.find('.loader');
      $modal = $('#successModal');
    }

    $form.find('.error-msg').remove();
    $form.find('button[type=submit]').blur();
    $loader.show();
    var data = $form.serializeArray();
    $.each(data, function (i, dataItem) {
      var countryCode = $form.find('.iti__selected-dial-code').text();

      if ((dataItem.name === 'phone' || dataItem.name === 'tel') && countryCode) {
        dataItem.value = countryCode + $form.find("input[name=phone]").val();
      }
    });

    if ($(this).hasClass('calculate-modal')) {
      data = data.concat($('.calculate-form').serializeArray());
    }

    if ($(this).hasClass('configurator-modal')) {
      var confData = $('.configurator-form').serializeArray();
      data = data.concat(confData);
    }

    var honeypot = $form.find('[name="formHoneypot"]');

    if (!honeypot.checked) {
      $.post($form.attr('action'), data, function (response) {
        response = JSON.parse(response);
        $loader.hide();

        if (response.status !== 'error') {
          var counters = response.counters;

          if (counters) {
            var goals = counters.goals;

            if (goals) {
              (0, _utils.sendGoals)(goals.ym ? goals.ym : '', goals.ga, goals.gads, goals.tmr, goals.ga4);
              (0, _utils.sendSocialGoals)({
                fbGoal: goals.fb,
                vkGoal: 'submit_application',
                vkEvent: 'lead'
              });
            }
          }

          if (isModal) {
            var $modalParts = $modal.find('.modal-header,.modal-body,.modal-footer');
            $modalParts.addClass('success');
            setTimeout(function () {
              $form.find('.form-control').val('');
              $modalParts.hide(300);
              $modal.find('.modal-content').append('<div class="response-message"></div>').find('.response-message').append(response.message);
            }, 300);
            $modal.on('hidden.bs.modal', function () {
              $modalParts.removeClass('success');
              $modalParts.show();
              $('.response-message').remove();
            });
          } else {
            $form.find('.form-control').val('');
            $modal.find('.response-message').html(response.message);
            $modal.modal('show');
          }

          if ($form.find('input[name="ebook"]')) {
            var btns = $('[data-download]');
            btns.attr('data-target', '#successModal');
            btns.addClass('allowed');
          }
        } else {
          $.each(response.errors, function (index, value) {
            var $input = $form.find('[name="' + value.field + '"]');

            if ($input.attr('type') !== 'radio') {
              $input.addClass('error').parent().append('<span class="error-msg">' + value.message + '</span>');
            } else {
              $input.addClass('error');
              $input.parents('.form-control-parent').append('<span class="error-msg">' + value.message + '</span>');
            }
          });
        }
      });
    }

    ;
  }); // remove errors on input change

  $(document).on('propertychange input change', '.form-control.error', function () {
    $(this).removeClass('error');
    var $parent = $(this).parents('.form-control-parent');
    var $msg = false;

    if ($parent.length > 0) {
      $msg = $parent.find('.error-msg');
    } else {
      $msg = $(this).parent().find('.error-msg');
    }

    $msg.fadeOut(300);
    setTimeout(function () {
      $msg.remove();
    });
  });
  $(document).on('propertychange input change', '.hidden-block-control', function () {
    var $this = $(this);
    var value = $('input[name="' + $(this).attr('name') + '"]:checked').val();
    var $group = $this.parents('.form-long__group');
    var $hiddenBlock = $group.find('.hidden-block');

    if (value === 'Да') {
      $hiddenBlock.addClass('active');
    } else {
      $hiddenBlock.removeClass('active');
    }
  });
})(window, document, jQuery);

},{"../../../js/app/utils":4}],9:[function(require,module,exports){
"use strict";

addEventListener("DOMContentLoaded", function (event) {
  var langSwitcher = document.getElementById('menu-lang-switcher');
  var topline = document.getElementById('topline');

  if (langSwitcher && topline) {
    var langSwitcherContainer = topline.querySelector('.topline__lang');
    var has_lagswitcher = langSwitcherContainer.querySelector('.lang-switcher');

    if (langSwitcherContainer && !has_lagswitcher) {
      langSwitcherContainer.appendChild(langSwitcher.childNodes[0]);
    }
  }
});
document.addEventListener('DOMContentLoaded', function () {
  var lazyItems = document.querySelectorAll('.custom-lazy[data-bg]');
  var options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  var onIntersect = function onIntersect(entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var el = entry.target;
        var bgUrl = el.getAttribute('data-bg');

        if (bgUrl) {
          el.style.backgroundImage = "url('".concat(bgUrl, "')");
          el.removeAttribute('data-bg');
        }

        observer.unobserve(el);
      }
    });
  };

  var observer = new IntersectionObserver(onIntersect, options);
  lazyItems.forEach(function (item) {
    observer.observe(item);
  });
});

},{}],10:[function(require,module,exports){
"use strict";

(function () {
  var lazyImages = [].slice.call(document.querySelectorAll("img.custom-lazy"));

  if ("IntersectionObserver" in window) {
    var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var lazyImage = entry.target;
          setImagesAttribute(lazyImage);
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });
    lazyImages.forEach(function (lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  } else {
    // fall back to a more compatible method here (basically for IE)
    var _lazyImages = [].slice.call(document.querySelectorAll("img.custom-lazy"));

    var active = false;

    var lazyLoad = function lazyLoad() {
      if (active === false) {
        active = true;
        setTimeout(function () {
          _lazyImages.forEach(function (lazyImage) {
            if (lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0 && getComputedStyle(lazyImage).display !== "none") {
              setImagesAttribute(lazyImage);
              _lazyImages = _lazyImages.filter(function (image) {
                return image !== lazyImage;
              });

              if (_lazyImages.length === 0) {
                document.removeEventListener("scroll", lazyLoad);
                window.removeEventListener("resize", lazyLoad);
                window.removeEventListener("orientationchange", lazyLoad);
              }
            }
          });

          active = false;
        }, 200);
      }
    };

    document.addEventListener("scroll", lazyLoad);
    window.addEventListener("resize", lazyLoad);
    window.addEventListener("load", lazyLoad);
    window.addEventListener("orientationchange", lazyLoad);
  }

  function setImagesAttribute(lazyImage) {
    var imagesDataSrc = {
      'src': lazyImage.getAttribute('data-src'),
      'srcset': lazyImage.getAttribute('data-srcset')
    };

    if (imagesDataSrc.src) {
      lazyImage.src = lazyImage.getAttribute('data-src');
    }

    if (imagesDataSrc.srcset) {
      lazyImage.setAttribute('srcset', lazyImage.getAttribute('data-srcset'));
    }

    lazyImage.classList.remove("custom-lazy");
  }
})();

},{}],11:[function(require,module,exports){
"use strict";

(function (window, document, $) {
  var $mainCarousel = $(".main-screen__carousel");

  if ($mainCarousel.length) {
    var $carouselItems = $(".main-screen__carousel-item");

    if ($carouselItems.length > 1) {
      // add animate.css class(es) to the elements to be animated
      var setAnimation = function setAnimation(_elem, _InOut) {
        var animationEndEvent = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';

        _elem.each(function () {
          var $elem = $(this);
          var $animationType = 'animated ' + $elem.data('animation-' + _InOut);
          $elem.addClass($animationType).one(animationEndEvent, function () {
            $elem.removeClass($animationType); // remove animate.css Class at the end of the animations
          });
        });
      }; // Fired after current slide has been changed


      $mainCarousel.addClass('owl-carousel');
      $mainCarousel.owlCarousel({
        loop: true,
        items: 1,
        nav: true,
        navText: ['<span class="btn-slider btn-slider--prev btn-slider--dark" aria-hidden="true">' + '        <svg viewBox="0 0 16 16"  xmlns="http://www.w3.org/2000/svg">' + '        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6464 7.64667L7.99969 4L7.29259 4.70711L10.0862 7.50067H4V8.50067H10.0853L7.29259 11.2933L7.99969 12.0004L11.6464 8.35378L11.9999 8.00022L11.6464 7.64667Z"/>\n' + '        </svg>' + '      </span>', '<span class="btn-slider btn-slider--dark" aria-hidden="true">\n' + '        <svg viewBox="0 0 16 16"  xmlns="http://www.w3.org/2000/svg">\n' + '        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6464 7.64667L7.99969 4L7.29259 4.70711L10.0862 7.50067H4V8.50067H10.0853L7.29259 11.2933L7.99969 12.0004L11.6464 8.35378L11.9999 8.00022L11.6464 7.64667Z"/>\n' + '         </svg>\n' + '       </span>'],
        navContainer: '#owl-nav',
        dotsContainer: '#owl-dots-container',
        lazyLoad: true,
        navSpeed: 500,
        animateIn: '-',
        dragMove: false,
        responsive: {
          992: {
            mouseDrag: false
          },
          1200: {
            autoplay: true,
            autoplayHoverPause: true,
            autoplaySpeed: 5000
          }
        },
        onInitialized: function onInitialized() {
          var $mainCarouselHiddenItems = $(".main-screen__carousel-item.hidden");
          $mainCarouselHiddenItems.removeClass('hidden');
        }
      });
      $mainCarousel.on('changed.owl.carousel', function (event) {
        var $currentItem = $('.owl-item', $mainCarousel).eq(event.item.index);
        var $elemsToanim = $currentItem.find("[data-animation-in]");
        setAnimation($elemsToanim, 'in');
      });
    }
  }
})(window, document, jQuery);

},{}],12:[function(require,module,exports){
"use strict";

(function (window, document, $) {
  $('[data-toggle="modal"]').on('click', function () {
    var $this = $(this);
    var target = $this.data('target');
    var $modal = $(target);
    var $ebook = $modal.find('input[name=ebook]');
    var downloadAttr = $this.attr('data-id');
    var $senpulseField = $modal.find('input[name=sendpulseBookId]');
    var sendpulseBook = $this.attr('data-sendpulse-book');

    if (!$ebook.length && target !== '#empty-modal' && downloadAttr === undefined) {
      $modal.find('.modal-header--title').text($this.text());
    }

    if (target === '#empty-modal') {
      $modal.find('.modal-header .modal-header--title').text($this.parents('.license__item').find('.license__title').text());
      $modal.find('.modal-body').html('<div class="content-wrapper">' + $this.data('content') + '');
      $modal.find('.modal-body').append('<div class="img-wrapper"><a href="' + $this.data('img') + '" data-fancybox><img src="' + $this.data('img') + '"></a></div></div>');
    }

    if (downloadAttr) {
      $ebook.val(downloadAttr);
      $modal.find('input[name=id]').val($this.attr('data-form-id'));
    }

    if ($senpulseField) {
      $senpulseField.val(sendpulseBook);
    }

    if (typeof fbq === 'function') {
      fbq('track', 'InitiateCheckout');
    }
  });
})(window, document, jQuery);

},{}],13:[function(require,module,exports){
"use strict";

/**
 * Owl init
 */
(function (window, document, $) {
  var $clientsCarousel = $(".clients-carousel");
  var $carouselMobileMain = $('.carousel-mobile-main');
  var $tickerCarousel = $('.ticker-carousel');

  if ($clientsCarousel.length) {
    $clientsCarousel.owlCarousel({
      loop: true,
      nav: true,
      animateIn: 'f',
      responsive: {
        0: {
          items: 1.1,
          dots: true,
          dotsEach: 1
        },
        576: {
          items: 1
        }
      },
      navText: ['<span class="btn-slider btn-slider--prev btn-slider--transparent" aria-hidden="true">' + '        <svg viewBox="0 0 16 16"  xmlns="http://www.w3.org/2000/svg">' + '        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6464 7.64667L7.99969 4L7.29259 4.70711L10.0862 7.50067H4V8.50067H10.0853L7.29259 11.2933L7.99969 12.0004L11.6464 8.35378L11.9999 8.00022L11.6464 7.64667Z"/>\n' + '        </svg>' + '      </span>', '<span class="btn-slider btn-slider--transparent" aria-hidden="true">\n' + '        <svg viewBox="0 0 16 16"  xmlns="http://www.w3.org/2000/svg">\n' + '        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6464 7.64667L7.99969 4L7.29259 4.70711L10.0862 7.50067H4V8.50067H10.0853L7.29259 11.2933L7.99969 12.0004L11.6464 8.35378L11.9999 8.00022L11.6464 7.64667Z"/>\n' + '         </svg>\n' + '       </span>'],
      dots: 'true'
    });

    if (window.innerWidth >= 992) {
      // add animate.css class(es) to the elements to be animated
      var setAnimation = function setAnimation(_elem, _InOut) {
        var animationEndEvent = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';

        _elem.each(function () {
          var $elem = $(this);
          var $animationType = 'animated ' + $elem.data('animation-' + _InOut);
          $elem.addClass($animationType).one(animationEndEvent, function () {
            $elem.removeClass($animationType); // remove animate.css Class at the end of the animations
          });
        });
      }; // Fired after current slide has been changed


      $clientsCarousel.on('mouseenter', '.card-def__link', function () {
        if (!$clientsCarousel.find('.card-def__link').hasClass('hovered')) {
          $clientsCarousel.closest('.section').css({
            'overflow': 'hidden'
          });

          if (window.innerWidth < 1200) {
            $clientsCarousel.find('.owl-stage-outer').css({
              'z-index': '1',
              'margin': '-60px -200px -280px',
              'padding': '60px 200px 280px'
            });
          } else {
            $clientsCarousel.find('.owl-stage-outer').css({
              'z-index': '1',
              'margin': '-80px -200px -240px',
              'padding': '80px 200px 240px'
            });
          }

          if (window.innerWidth >= 1400) {
            $clientsCarousel.find('.owl-nav button').css({
              'margin-top': '-15px'
            });
          } else {
            $clientsCarousel.find('.owl-nav button').css({
              'margin-top': '-8px'
            });
          }

          $clientsCarousel.find('.card-def__link').addClass('hovered');
        }
      });
      $clientsCarousel.on('mouseleave', '.card-def__link', function () {
        if ($clientsCarousel.find('.card-def__link').hasClass('hovered')) {
          $clientsCarousel.closest('.section').css({
            'overflow': ''
          });
          $clientsCarousel.find('.owl-stage-outer').css({
            'z-index': '',
            'margin': '',
            'padding': ''
          });
          $clientsCarousel.find('.owl-nav button').css({
            'margin-top': ''
          });
          $clientsCarousel.find('.card-def__link').removeClass('hovered');
        }
      });
      $clientsCarousel.on('changed.owl.carousel', function (event) {
        var $currentItem = $('.owl-item', $clientsCarousel).eq(event.item.index);
        var $elemsToanim = $currentItem.find("[data-animation-in]");
        setAnimation($elemsToanim, 'in');
      });
    }
  }

  if ($carouselMobileMain.length) {
    var args = {
      loop: true,
      dots: true,
      responsive: {
        0: {
          items: 1.1,
          dotsEach: 1
        },
        576: {
          items: 2.1,
          dotsEach: 1
        },
        992: {
          items: 2,
          dotsEach: 1
        }
      }
    };

    var carouselMobileEnable = function carouselMobileEnable(args) {
      var innerWidth = window.innerWidth;
      var $carousel = $(".carousel-mobile-main:not(.owl-loaded)");
      var $carouselLoaded = $(".carousel-mobile-main");

      if (innerWidth >= 1200) {
        $carouselLoaded.trigger('destroy.owl.carousel');
        $carouselLoaded.addClass('row');
        $carouselLoaded.removeClass('owl-carousel');
      } else {
        $carousel.removeClass('row');
        $carousel.addClass('owl-carousel');
        $carousel.owlCarousel(args);
      }
    };

    carouselMobileEnable(args);
    window.addEventListener('resize', function () {
      carouselMobileEnable(args);
    });
    $carouselMobileMain.on('mouseenter', '.card-def__link', function () {
      $carouselMobileMain.closest('.section').css({
        'overflow': 'hidden'
      });
      $carouselMobileMain.find('.owl-stage-outer').css({
        'z-index': '1',
        'margin': '-60px -200px -240px',
        'padding': '60px 200px 240px'
      });
    });
    $carouselMobileMain.on('mouseleave', '.card-def__link', function () {
      $carouselMobileMain.closest('.section').css({
        'overflow': ''
      });
      $carouselMobileMain.find('.owl-stage-outer').css({
        'z-index': '',
        'margin': '',
        'padding': ''
      });
    });
  }

  if ($tickerCarousel.length) {
    $tickerCarousel.owlCarousel({
      autoplay: true,
      slideTransition: 'linear',
      autoplayTimeout: 2000,
      smartSpeed: 2000,
      loop: true,
      center: true,
      nav: false,
      dots: false,
      autoWidth: true,
      responsive: {
        0: {
          margin: 40,
          items: 2
        },
        360: {
          margin: 40,
          items: 3
        },
        576: {
          margin: 40,
          items: 4
        },
        768: {
          margin: 80,
          items: 5
        },
        992: {
          margin: 80,
          items: 6
        },
        1400: {
          margin: 80,
          items: 7
        },
        1600: {
          margin: 80,
          items: 8
        },
        1800: {
          margin: 80,
          items: 10
        }
      }
    });
  }

  $('.owl-carousel').each(function () {
    //Find each set of dots in this carousel
    $(this).find('.owl-dot').each(function (index) {
      //Add one to index so it starts from 1
      $(this).attr('aria-label', 'Go to slider number ' + (index + 1));
    });
  });
})(window, document, jQuery);

},{}],14:[function(require,module,exports){
"use strict";

if (!Element.prototype.closest) {
  Element.prototype.closest = function (css) {
    var node = this;

    while (node) {
      if (node.matches(css)) return node;else node = node.parentElement;
    }

    return null;
  };
}

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector;
}

if ('NodeList' in window && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;

    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

},{}],15:[function(require,module,exports){
"use strict";

//TODO remove
(function (window, document, $) {
  var $body = $('body');
  var $header = $('.header');

  if ($header.length) {
    var headerPosition = $header.offset().top;
    var headerHeight = $header.outerHeight();
    var breakPoint = 50; // Fixed header menu

    $(window).on('load scroll', function () {
      var scrollPos = $(this).scrollTop();

      if (scrollPos > breakPoint) {
        if (!$body.hasClass('fixed-header')) {
          $body.addClass('fixed-header');

          if (window.innerWidth > 1600 && !$header.hasClass('header--white')) {
            $header.addClass('fixed');
            $header.animate({
              'top': '0'
            }, 200);
          }
        }
      } else if ($body.hasClass('fixed-header') && scrollPos < headerPosition + headerHeight) {
        $body.removeClass('fixed-header').attr('style', '');

        if (window.innerWidth > 1600 && !$header.hasClass('header--white')) {
          $header.removeClass('fixed');
          $header.attr('style', '');
        }
      }
    });
  }
})(window, document, jQuery);

},{}],16:[function(require,module,exports){
"use strict";

var inputs = document.querySelectorAll('.input-wrapper input, .input-wrapper .input');

var inputFocus = function inputFocus(e) {
  var input = e.target;
  var inputControl = input.parentElement;
  inputControl.classList.add('focused');
};

var inputBlur = function inputBlur(e) {
  var input = e.target;
  var inputControl = input.parentElement;
  inputControl.classList.remove('focused');

  if (input.value !== '') {
    inputControl.classList.add('filled');
    inputControl.classList.remove('error');
  } else {
    inputControl.classList.remove('filled');
  }
};

var inputTyping = function inputTyping(e) {
  var input = e.target;
  var inputControl = input.parentElement;
  var errorMsg = inputControl.querySelector('.error-msg');
  input.classList.remove('error');

  if (errorMsg) {
    errorMsg.remove();
  }
};

if (inputs.length) {
  inputs.forEach(function (item) {
    item.addEventListener('focus', inputFocus);
    item.addEventListener('blur', inputBlur);
    item.addEventListener('input', inputTyping);
  });
}

},{}]},{},[5]);
